import de from "../i18n/de.json";
import en from "../i18n/en.json";

export const defaultLocale = window.ocm?.config?.language ?? "de";
export const fallbackLocale = "en";
export const sharedMessages = { de, en };
